import "../../shared/sparkle_uber_select.js";

jQuery(function () {
  jQuery("[data-behaviour~=nested-uber-select]").uberSelect(window.UberSelectExtensions.nestedOptions);
});
